import { render, staticRenderFns } from "./faqi.vue?vue&type=template&id=5d9f9897&scoped=true"
import script from "./faqi.vue?vue&type=script&lang=js"
export * from "./faqi.vue?vue&type=script&lang=js"
import style0 from "./faqi.vue?vue&type=style&index=0&id=5d9f9897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f9897",
  null
  
)

export default component.exports